module.exports = __webpack_public_path__ + "static/media/PRADYUT-SINHA.1a5bf6de.png";